<template>
  <div>
    <a
      style="color:#424242"
      :tooltip="$t('orders.processThisOrderTooltip')"
      @click="
        ;(checkAlert = false),
          (dialog = true),
          (updateData.total_amount = 0),
          (updateData.local_delivery = 0),
          (theQuantity.quantity = r.quantity),
          (updateData.quantity_charge = r.quantity_charge),
          calculateTotalAmount(),
          getExchangeRate(),
          getAEDRate(),
          getCNYRate(),
          getGBPRate(),
          getEURRate()
      "
    >
      <i class="material-icons">settings</i>
    </a>

    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="dialog"
        persistent
        max-width="1300px"
      >
        <v-card>
          <form
            action=""
            @submit.prevent="submitOrder($event, r.order_id)"
          >
            <v-card-title>
              <v-flex
                xs11
                sm11
                md11
              >
                <span class="headline"> <strong> {{ $t('customer.editOrderTooltip') }} <span class="text-primary ml-2">#{{ r.theOrderID }}</span> </strong></span>
              </v-flex>
              <v-flex
                xs1
                sm1
                md1
              >
                <v-btn
                  flat
                  @click.native="clearProcessOrderData(), (dialog = false), $validator.reset()"
                  class="close"
                ><span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
              <div class="col-md-12">
                <!-- removed: Customer ID/Name/Note static row -->
                <!-- removed: Product Name/URL static row -->
                <!-- removed: Qty/Size/Color/Type/Coupon static row -->
                <div class="col-md-8" style="padding: 0px;">
                  <!-- removed: Order Note static row -->
                  <div class="row" style="margin:5px 0; background-color: #FAF8F8FF;border:1px solid #bbb; border-radius: 5px;">

                    <h5 class="col-sm-12 col-md-6">
                      <v-flex
                    xs12
                    sm12
                    md12
                  >
                    <v-select
                      :items="warehouses"
                      item-value="value"
                      v-model="r.warehouse_id_fk"
                      :error-messages="errors.collect('Warehouse')"
                      data-vv-name="Warehouse"
                      @input="editWarehouse(r.order_id,r.warehouse_id_fk)"
                      :label="$t('columns.warehouse') + '*'"
                      v-validate="'required'"
                    ></v-select>
                  </v-flex>
                    </h5>
                    <h5
                      class="col-sm-12 col-md-6"
                      style="display:none"
                    >
                      <v-flex
                    xs12
                    sm12
                    md12
                  >
                        <v-select
                          v-model="r.transportation_type"
                          :items="r.warehouse.transportation_types"
                          item-value="id"
                          item-text="name"
                          @input="editTransportationTypeSave(r.order_id,r.transportation_type)"
                          :label="$t('columns.transportationType')"
                        />
                      </v-flex>
                    </h5>
                    <!-- hidden: Order Type select (reversible)
                    <h5 class="col-sm-12 col-md-4 d-flex align-items-center" style="gap: 12px;">
                      <v-select
                        v-model="order_type_id_fk"
                        :items="orderTypes"
                        item-value="value"
                        :error-messages="errors.collect('order_type_id_fk')"
                        data-vv-name="order_type_id_fk"
                        @input="handleOrderTypeChange"
                        label="Order Type*"
                        v-validate="'required'"
                      >
                      </v-select>
                    </h5>
                    <h5 class="col-sm-12" :class="r.coupon != null ? 'col-md-6' : 'col-md-12'">
                      <strong> Price/Weight {{ r.country }}: </strong>
                      ${{ selectedOrderTypePrice }}
                    </h5>
                    <h5 v-if="r.coupon != null" class="col-sm-12 col-md-6">
                      <strong> Coupon: </strong> {{ r.coupon }}
                      <span style="font-size: small"><strong>percentage:</strong> </span>
                      {{ r.percentage }}%
                    </h5>
                    -->
                  </div>
                </div>
                <div class="col-md-4" style="padding: 0px;">
                  <div style="margin:5px 0 0 5px;border:1px solid #bbb;border-radius: 5px;">
                    <img
                      v-if="r.image"
                      :src="r.image.startsWith('http') ? r.image : `${$_image_path()}${r.image}`"
                      :alt="$t('columns.image')"
                      width="100%"
                      height="195px"
                      style="border-radius: 4px; object-fit: contain; cursor: pointer;"
                      @click="showImage(r.image)"
                    >
                    <img
                      v-else
                      src="../../assets/images/black_shipzone.png"
                      :alt="$t('columns.image')"
                      width="100%"
                      height="193px"
                      style="border-radius: 4px; object-fit: contain; cursor: pointer;"
                    >
                  </div>
                  </div>
              </div>

              <!-- <h5
                class="col-sm-12 col-md-3"
                v-if="r.country == 'Turkey'"
              >
                <strong> Quantity Charge <span style="font-size: small">base</span>: </strong>
                {{ r.quantity_charge_base_turkey }}
                <span style="font-size: 15px">
                  <a @click="openEditQttBaseTurkeyModal(r.user_id, r.order_id)">edit?</a>
                </span>
              </h5>
              <h5
                class="col-sm-12 col-md-3"
                v-else
              >
                <strong> Quantity Charge <span style="font-size: small">base</span>: </strong>
                {{ r.quantity_charge_base_usa }}
                <span style="font-size: 15px">
                  <a @click="openEditQttBaseUSAModal(r.user_id, r.order_id)">edit?</a>
                </span>
              </h5>
              <h5
                class="col-sm-12 col-md-3"
                v-if="r.country == 'Turkey'"
              >
                <strong> Quantity Charge <span style="font-size: small">other</span>: </strong>
                {{ r.quantity_charge_other_turkey }}
                <span style="font-size: 15px">
                  <a @click="openEditQttOtherTurkeyModal(r.user_id, r.order_id)">edit?</a>
                </span>
              </h5>
              <h5
                class="col-sm-12 col-md-3"
                v-else
              >
                <strong> Quantity Charge <span style="font-size: small">other</span>: </strong>
                {{ r.quantity_charge_other_usa }}
                <span style="font-size: 15px">
                  <a @click="openEditQttOtherUSAModal(r.user_id, r.order_id)">edit?</a>
                </span>
              </h5> -->
              <!-- <h5
                v-if="r.country === 'Turkey'"
                class="col-sm-12 col-md-3"
              >
                <strong> Price Per Weight Turkey: </strong> ${{ r.item_weight_price_turkey }}
                <span style="font-size: 15px">
                  <a @click="openEdit1Modal(r.user_id)">edit?</a>
                </span>
              </h5> -->

              <!-- <h5 class="col-sm-12 col-md-3">
                <strong> DeliveryType:</strong>officeDelivery<span style="font-size: 15px"> -->
                  <!-- <a @click="openEditDeliveryTypeModal(r.order_id)">edit?</a> -->
                <!-- </span>
              </h5> -->


              <div class="row">
                <!-- <div class="col-sm-10">
                  <div class="row"> -->
                    <!-- <h5
                      v-if="r.country == 'Turkey'"
                      class="col-sm-12 col-md-12"
                    >
                      <strong> &nbsp; Tip: </strong>
                      <span style="text-decoration: underline">ShipZone Fee</span> is
                      <b>${{ defaultPriceData.kreenex_fee_turkey }}</b> if
                      <i style="text-decoration: underline"> Item price</i> less than
                      <b>${{ defaultPriceData.kreenex_fee_base_turkey }}</b>, if <i style="text-decoration: underline">Item price </i> is more we get ShipZone
                      fee by this function
                      <i style="text-decoration: underline">
                        {{ defaultPriceData.kreenex_fee_turkey }} + (item price *
                        {{ defaultPriceData.kreenex_fee_percentage }})</i>
                    </h5> -->
                    <!-- <h5
                      v-else
                      class="col-sm-12 col-md-12"
                    >
                      <strong> &nbsp; Tip: </strong>
                      <span style="text-decoration: underline">ShipZone Fee</span> is
                      <b>${{ defaultPriceData.kreenex_fee_usa }}</b> if
                      <i style="text-decoration: underline"> Item price</i> less than
                      <b>${{ defaultPriceData.kreenex_fee_base_usa }}</b>, if <i style="text-decoration: underline">Item price </i> is more we get ShipZone
                      fee by this function
                      <i style="text-decoration: underline">
                        {{ defaultPriceData.kreenex_fee_usa }} + (item price *
                        {{ defaultPriceData.kreenex_fee_percentage }})</i>
                    </h5> -->
                  <!-- </div>
                </div> -->

              </div>
            </v-card-title>

            <v-card-text>
              <v-alert
                type="success"
                :value="checkAlert"
              >
                {{ $t('orders.theOrderIsProcessed') }}
              </v-alert>

               <v-layout wrap>

                <!-- ===== Edit Order Info Section (Phase 2) ===== -->
                <div class="col-md-12" style="color:#2d315c;border-bottom:1px solid #2d315c;margin-bottom:5px;">
                  <h4>{{ $t('orders.editOrderInfoSection') }}</h4>
                </div>

                <v-flex class="px-2" xs12 sm12 md4>
                  <v-select
                    :items="customers"
                    item-value="value"
                    item-text="text"
                    v-model="updateData.customer_id_fk"
                    :label="$t('columns.customerName')"
                    disabled
                    :hint="$t('orders.customerLockedHint')"
                    persistent-hint
                  ></v-select>
                </v-flex>

                <v-flex class="px-2" xs12 sm12 md4>
                  <v-text-field
                    :label="$t('orders.requestName')"
                    v-model="updateData.product_name"
                  ></v-text-field>
                </v-flex>

                <v-flex class="px-2" xs12 sm12 md4>
                  <v-text-field
                    :label="$t('orders.requestLink')"
                    v-model="updateData.product_url"
                  ></v-text-field>
                </v-flex>

                <v-flex class="px-2" xs12 sm12 md2>
                  <v-text-field
                    :label="$t('columns.quantity')"
                    v-model.number="updateData.quantity"
                    type="number"
                    @input="theQuantity.quantity = updateData.quantity; calculateTotalAmount()"
                    :error-messages="errors.collect('Quantity')"
                    v-validate="'integer|min_value:1'"
                    data-vv-name="Quantity"
                  ></v-text-field>
                </v-flex>

                <v-flex class="px-2" xs12 sm12 md2>
                  <v-text-field
                    :label="$t('customer.color')"
                    v-model="updateData.color"
                  ></v-text-field>
                </v-flex>

                <v-flex class="px-2" xs12 sm12 md3>
                  <v-text-field
                    :label="$t('columns.brand')"
                    v-model="updateData.brand"
                  ></v-text-field>
                </v-flex>

                <v-flex class="px-2" xs12 sm12 md2>
                  <v-text-field
                    :label="$t('columns.size')"
                    v-model="updateData.size"
                  ></v-text-field>
                </v-flex>

                <v-flex xs12 sm12 md3>
                  <div class="col-md-12 d-flex align-items-center">
                    <v-btn
                      block
                      @click="triggerOrderImageInput"
                      style="margin: 16px; max-width: 220px; display: flex; align-items: center; justify-content: center;"
                    >
                      {{ $t('orders.uploadOrderImage') }}
                    </v-btn>
                    <input
                      type="file"
                      ref="orderImageInput"
                      style="display: none"
                      accept="image/*"
                      @change="handleOrderImageUpload"
                    />
                    <img
                      v-if="orderImagePreview"
                      :src="orderImagePreview"
                      :alt="$t('columns.preview')"
                      style="width: 50px; height: 50px; object-fit: cover; border: 1px solid #ccc; flex: none !important"
                    />
                    <span
                      v-if="orderImageName"
                      style="display: flex; align-items: center; font-size: 12px;" class="rtl-ml-6"
                    >{{ orderImageName }}</span>
                  </div>
                </v-flex>

                <v-flex class="px-2" xs12 sm12 md12>
                  <v-text-field
                    :label="$t('orders.requestDescription')"
                    v-model="updateData.note"
                    multi-line
                    :rows="2"
                  ></v-text-field>
                </v-flex>
                <!-- ===== End Edit Order Info Section ===== -->

                <!-- hidden: Item Price TL (Turkey, reversible)
                <v-flex class="px-2" v-if="r.country === 'Turkey'" xs12 sm12 md3 lg2>
                  <v-text-field label="Item Price TL*" v-model.number="updateData.the_tl_price"
                    @input="calculateUSDPrice(updateData.the_tl_price, r.country)"
                    @change="calculateUSDPrice(updateData.the_tl_price, r.country)"
                    :error-messages="errors.collect('Item price TL')"
                    v-validate="'required|decimal:2'" data-vv-name="Item price TL">
                  </v-text-field>
                </v-flex>
                -->

                <div class="col-md-12" style="color:#2d315c;border-bottom:1px solid #2d315c;margin-bottom:5px;">
                  <h4>{{ $t('orders.editOrderPriceSection') }}</h4>
                </div>
                <v-flex
                  class="px-2"
                  v-if="r.country === 'Turkey'"
                  xs12
                  sm12
                  md3
                  lg3
                >
                  <v-text-field
                    :label="$t('orders.itemPriceLabel', { unit: '₺' })"
                    v-model.number="updateData.the_tl_price"
                    @input="calculateUSDPrice(updateData.the_tl_price)"
                    @change="calculateUSDPrice(updateData.the_tl_price)"
                    :error-messages="errors.collect('Item price TL')"
                    v-validate="'required|decimal:2'"
                    data-vv-name="Item price TL"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="px-2"
                  v-else-if="r.country === 'UAE'"
                  xs12
                  sm12
                  md3
                  lg3
                >
                  <v-text-field
                    :label="$t('orders.itemPriceLabel', { unit: 'AED' })"
                    v-model.number="updateData.the_aed_price"
                    @input="calculateAEDPrice(updateData.the_aed_price)"
                    @change="calculateAEDPrice(updateData.the_aed_price)"
                    :error-messages="errors.collect('Item price AED')"
                    v-validate="'required|decimal:2'"
                    data-vv-name="Item price AED"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="px-2"
                  v-else-if="r.country === 'China'"
                  xs12
                  sm12
                  md3
                  lg3
                >
                  <v-text-field
                    :label="$t('orders.itemPriceLabel', { unit: '¥' })"
                    v-model.number="updateData.the_cny_price"
                    @input="calculateCNYPrice(updateData.the_cny_price)"
                    @change="calculateCNYPrice(updateData.the_cny_price)"
                    :error-messages="errors.collect('Item price CNY')"
                    v-validate="'required|decimal:2'"
                    data-vv-name="Item price CNY"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="px-2"
                  v-else-if="isGbpPricedOrder"
                  xs12
                  sm12
                  md3
                  lg3
                >
                  <v-text-field
                    :label="$t('orders.itemPriceLabel', { unit: '£' })"
                    v-model.number="updateData.the_gbp_price"
                    @input="calculateGBPPrice(updateData.the_gbp_price)"
                    @change="calculateGBPPrice(updateData.the_gbp_price)"
                    :error-messages="errors.collect('Item price GBP')"
                    v-validate="'required|decimal:2'"
                    data-vv-name="Item price GBP"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="px-2"
                  v-else-if="r.country === 'Germany'"
                  xs12
                  sm12
                  md3
                  lg3
                >
                  <v-text-field
                    :label="$t('orders.itemPriceLabel', { unit: '€' })"
                    v-model.number="updateData.the_eur_price"
                    @input="calculateEURPrice(updateData.the_eur_price)"
                    @change="calculateEURPrice(updateData.the_eur_price)"
                    :error-messages="errors.collect('Item price EUR')"
                    v-validate="'required|decimal:2'"
                    data-vv-name="Item price EUR"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="px-2"
                  v-else
                  xs12
                  sm12
                  md3
                  lg3
                >
                  <v-text-field
                    :label="$t('orders.itemPriceLabel', { unit: '$' })"
                    v-model.number="updateData.item_price"
                    @input="calculateTotalAmount(),calculateIntShipping()"
                    @change="calculateTotalAmount(),calculateIntShipping()"
                    :error-messages="errors.collect('Item price')"
                    v-validate="'required|decimal:2'"
                    data-vv-name="Item price"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  v-if="!r.coupon"
                  xs12
                  sm12
                  md3
                  lg3
                >
                  <v-text-field
                    :label="$t('columns.shipping') + ' ($)'"
                    v-model.number="updateData.internal_shipping_handling"
                    @input="isShipmentManual = true; calculateTotalAmount()"
                    @change="calculateTotalAmount()"
                    :error-messages="errors.collect('Int. Shipping')"
                    v-validate="'required|decimal:2'"
                    data-vv-name="Int. Shipping"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  v-if="!!r.coupon"
                  xs12
                  sm12
                  md3
                  lg3
                >
                  <v-text-field
                    :label="$t('columns.shipping') + ' ($)'"
                    v-model.number="temp_shipping"
                    @input="applyShippingDiscount()"
                    @change="applyShippingDiscount()"
                    :error-messages="errors.collect('Int. Shipping Raw')"
                    v-validate="'decimal:2'"
                    data-vv-name="Int. Shipping Raw"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  v-if="!!r.coupon"
                  xs12
                  sm12
                  md3
                  lg3
                >
                  <v-text-field
                    :label="$t('orders.discountedShippingPriceLabel')"
                    v-model.number="updateData.internal_shipping_handling"
                    @input="calculateTotalAmount()"
                    @change="calculateTotalAmount()"
                    :error-messages="errors.collect('Int. Shipping Discounted')"
                    v-validate="'decimal:2'"
                    data-vv-name="Int. Shipping Discounted"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md3
                  lg3
                >
                  <v-text-field
                    :label="$t('columns.tax') + ' ($)'"
                    v-model.number="updateData.national_tax"
                    @input="calculateTotalAmount()"
                    @change="calculateTotalAmount()"
                    :error-messages="errors.collect('International Tax')"
                    v-validate="'decimal:2'"
                    data-vv-name="International Tax"
                  ></v-text-field>
                </v-flex>

                <!-- hidden: Delivery Price (USD) v-if="false"
                <v-flex class="px-2" xs12 sm12 md6 lg3>
                  <v-text-field label="Delivery Price" v-model.number="updateData.delivery_price"
                    @input="calculateTotalAmount()" @change="calculateTotalAmount()"
                    :error-messages="errors.collect('Delivery price')" v-validate="'decimal:2'"
                    data-vv-name="Delivery price"></v-text-field>
                </v-flex>
                -->

                <!-- hidden: Local Delivery (USD) v-if="false"
                <v-flex class="px-2" xs12 sm12 md6 lg3>
                  <v-text-field label="Local Delivery" v-model.number="updateData.local_delivery"
                    @input="calculateTotalAmount()" :error-messages="errors.collect('Local Delivery')"
                    v-validate="'decimal:2'" data-vv-name="Local Delivery"></v-text-field>
                </v-flex>
                -->

                <!-- hidden: Item Weight KG+LB v-if="false"
                <v-flex class="px-2" xs12 sm12 md6 lg3>
                  <v-layout row wrap>
                    <v-flex class="px-2" xs12 sm12 md6 lg6>
                      <v-text-field label="Item Weight (KG)" v-model.number="updateData.item_weight"
                        @input="calculateIntShipping(),calculateTotalAmount()" @change="calculateTotalAmount()"
                        :error-messages="errors.collect('Item weight')" v-validate="'decimal'" data-vv-name="Item weight">
                      </v-text-field>
                    </v-flex>
                    <v-flex class="px-2" xs12 sm12 md6 lg6>
                      <v-text-field label="Item Weight (LB)" v-model.number="updateData.item_weight_lb"
                        @input="convertLbToKg" @change="convertLbToKg" v-validate="'decimal'" data-vv-name="Item weight (LB)">
                      </v-text-field>
                    </v-flex>
                  </v-layout>
                </v-flex>
                -->

                <!-- hidden: Local Tax v-if="false"
                <v-flex class="px-2" xs12 sm12 md6 lg3>
                  <v-text-field label="Local Tax" v-model.number="updateData.tax"
                    @input="calculateTotalAmount()" @change="calculateTotalAmount()"
                    :error-messages="errors.collect('tax')" v-validate="'decimal:2'" data-vv-name="tax">
                  </v-text-field>
                </v-flex>
                -->

                <!-- hidden: ShipZone Fee v-if="false"
                <v-flex class="px-2" xs12 sm12 md6 lg3>
                  <v-text-field label="ShipZone Fee" v-model.number="updateData.kreenex_fee"
                    @input="calculateTotalAmount()" @change="calculateTotalAmount()"
                    :error-messages="errors.collect('ShipZone fee')" v-validate="'decimal:2'"
                    data-vv-name="ShipZone fee" :readonly="!$_has_perm('add_company_fee_at_process')">
                  </v-text-field>
                </v-flex>
                -->

                <!-- ===== New top-level fields (Phase 3) ===== -->
                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md3
                  lg3
                  v-if="$_has_perm('add_discount_at_process') && r.country === 'Turkey'"
                >
                  <v-text-field
                    :label="$t('orders.discountLabel', { unit: '₺' })"
                    @input="setDiscountFromTL()"
                    @change="setDiscountFromTL()"
                    v-model.number="tlDiscount"
                    :error-messages="errors.collect('Discount')"
                    v-validate="'decimal:2'"
                    data-vv-name="Discount"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md3
                  lg3
                  v-if="$_has_perm('add_discount_at_process') && r.country === 'UAE'"
                >
                  <v-text-field
                    :label="$t('orders.discountLabel', { unit: 'AED' })"
                    @input="setDiscountFromAED()"
                    @change="setDiscountFromAED()"
                    v-model.number="aedDiscount"
                    :error-messages="errors.collect('Discount')"
                    v-validate="'decimal:2'"
                    data-vv-name="Discount"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md3
                  lg3
                  v-if="$_has_perm('add_discount_at_process') && r.country === 'China'"
                >
                  <v-text-field
                    :label="$t('orders.discountLabel', { unit: '¥' })"
                    @input="setDiscountFromCNY()"
                    @change="setDiscountFromCNY()"
                    v-model.number="cnyDiscount"
                    :error-messages="errors.collect('Discount')"
                    v-validate="'decimal:2'"
                    data-vv-name="Discount"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md3
                  lg3
                  v-if="$_has_perm('add_discount_at_process') && isGbpPricedOrder"
                >
                  <v-text-field
                    :label="$t('orders.discountLabel', { unit: '£' })"
                    @input="setDiscountFromGBP()"
                    @change="setDiscountFromGBP()"
                    v-model.number="gbpDiscount"
                    :error-messages="errors.collect('Discount')"
                    v-validate="'decimal:2'"
                    data-vv-name="Discount"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md3
                  lg3
                  v-if="$_has_perm('add_discount_at_process') && r.country === 'Germany'"
                >
                  <v-text-field
                    :label="$t('orders.discountLabel', { unit: '€' })"
                    @input="setDiscountFromEUR()"
                    @change="setDiscountFromEUR()"
                    v-model.number="eurDiscount"
                    :error-messages="errors.collect('Discount')"
                    v-validate="'decimal:2'"
                    data-vv-name="Discount"
                  ></v-text-field>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md3
                  lg3
                  v-if="$_has_perm('add_discount_at_process') && r.country !== 'Turkey' && r.country !== 'UAE' && r.country !== 'China' && !isGbpPricedOrder && r.country !== 'Germany'"
                >
                  <v-text-field
                    :label="$t('orders.discountLabel', { unit: '$' })"
                    @input="calculateTotalAmount()"
                    @change="calculateTotalAmount()"
                    v-model.number="updateData.discount"
                    :error-messages="errors.collect('Discount')"
                    v-validate="'decimal:2'"
                    data-vv-name="Discount"
                  ></v-text-field>
                </v-flex>

                <v-flex class="px-2" xs12 sm12 md3 lg3>
                  <v-text-field
                    :label="$t('orders.deliveryIqdLabel')"
                    v-model.number="localDeliveryIqd"
                    @input="onLocalDeliveryIqdChange()"
                  ></v-text-field>
                </v-flex>

                <v-flex class="px-2" xs12 sm12 md3 lg3>
                  <v-text-field
                    :label="$t('orders.estimateTimeToArrivalLabel')"
                    v-model.number="estimateDays"
                    type="number"
                    @input="onEstimateDaysChange()"
                  ></v-text-field>
                </v-flex>

                <v-flex class="px-2" xs12 sm12 md6>
                  <v-text-field
                    :label="$t('columns.totalAmount') + ' ($)'"
                    v-model.number="updateData.total_amount"
                    :error-messages="errors.collect('total_amount')"
                    v-validate="'decimal:2'"
                    data-vv-name="total_amount"
                  ></v-text-field>
                </v-flex>
                <!-- ===== End new top-level fields ===== -->

                <!-- Customer Process Note + Reason select + Upload (moved from Notes section) -->
                <v-flex xs12 pa-0 ma-0 style="height:0"></v-flex>
                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                  lg4
                >
                  <v-text-field
                    :label="$t('orders.customerProcessNoteLabel')"
                    v-model="updateData.customer_process_note"
                    multi-line
                    :rows="3"
                  ></v-text-field>
                </v-flex>
                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md6
                  lg4
                >
                  <v-select
                    :items="reasons"
                    item-value="value"
                    item-text="text"
                    :label="$t('orders.reason')"
                    v-model="selectedNoteReason"
                    clearable
                    @input="insertReasonIntoNote"
                  ></v-select>
                </v-flex>
                <v-flex
                  xs12
                  sm12
                  lg4>
                  <div class="col-md-12 d-flex align-items-center">
                    <v-btn
                      block
                      @click="triggerFileInput"
                      style="margin: 16px;max-width: 300px; display: flex; align-items: center; justify-content: center;"
                    >
                      {{ $t('orders.uploadImage') }}
                    </v-btn>
                    <input
                      type="file"
                      ref="fileInput"
                      style="display: none"
                      accept="image/*"
                      v-validate="'max_file_size:2'"
                      data-vv-name="file"
                      @change="handleFileUpload"
                    />
                    <img
                      v-if="imagePreview"
                      :src="imagePreview"
                      :alt="$t('columns.preview')"
                      style="width: 70px; height: 70px; object-fit: cover; border: 1px solid #ccc; flex:none !important"
                    />
                    <span
                      v-if="updateData.fileName"
                      style="display: flex; align-items: center;" class="rtl-ml-15"
                    >
                      {{ updateData.fileName }}
                    </span>
                  </div>
                </v-flex>

                <!-- hidden: Additional Services expansion panel (v-if="false", kept for reversibility)
                <v-expansion-panel v-model="panel_hidden">
                  <v-expansion-panel-content>
                    <div slot="header" style="font-size: 14px; font-weight: bold;">Additional Services</div>
                    <v-layout row wrap pa-2>
                      <v-flex
                        class="px-2"
                        xs12
                        sm6
                        md3
                        lg3
                      >
                        <v-text-field
                          label="Insurance"
                          v-model.number="updateData.insurance"
                          @input="calculateTotalAmount()"
                          @change="calculateTotalAmount()"
                          :error-messages="errors.collect('insurance')"
                          v-validate="'decimal:2'"
                          data-vv-name="insurance"
                        ></v-text-field>
                      </v-flex>

                      <v-flex
                        class="px-2"
                        xs12
                        sm6
                        md3
                        lg3
                        v-if="$_has_perm('add_discount_at_process')"
                      >
                        <v-text-field
                          label="Discount"
                          @input="calculateTotalAmount()"
                          @change="calculateTotalAmount()"
                          v-model.number="updateData.discount"
                          :error-messages="errors.collect('Discount')"
                          v-validate="'decimal:2'"
                          data-vv-name="Discount"
                        ></v-text-field>
                      </v-flex>

                      <v-flex
                        class="px-2 d-flex align-center"
                        xs12
                        sm6
                        md3
                        lg2
                      >
                        <v-checkbox
                          v-model="updateData.is_repackage"
                          label="Repackage"
                          color="primary"
                          hide-details
                          class="ma-0 pa-0"
                          style="font-size: 16px; margin-bottom: 0;"
                        ></v-checkbox>
                      </v-flex>

                      <v-flex
                        class="px-2 d-flex align-center"
                        xs12
                        sm6
                        md3
                        lg2
                      >
                        <v-checkbox
                          v-model="updateData.is_hold"
                          label="Hold"
                          color="primary"
                          hide-details
                          class="ma-0 pa-0"
                          style="font-size: 16px; margin-bottom: 0;"
                        ></v-checkbox>
                      </v-flex>

                      <v-flex
                        class="px-2 d-flex align-center"
                        xs12
                        sm6
                        md3
                        lg2
                      >
                        <v-checkbox
                          v-model="has_other_service"
                          label="Other Service"
                          color="primary"
                          hide-details
                          class="ma-0 pa-0"
                          style="font-size: 16px; margin-bottom: 0;"
                        ></v-checkbox>
                      </v-flex>
                    </v-layout>

                    <v-layout row wrap class="col-md-12">
                      <v-flex
                        v-if="has_other_service || updateData.other_service"
                        class="px-2"
                        xs12
                        sm12
                        md6
                        lg3
                      >
                        <v-text-field
                          label="Other Service Price"
                          v-model.number="updateData.other_service_price"
                          @input="calculateTotalAmount()"
                          @change="calculateTotalAmount()"
                          :error-messages="errors.collect('Other Service Price')"
                          v-validate="'decimal:2'"
                          data-vv-name="Other Service Price"
                        ></v-text-field>
                      </v-flex>

                      <v-flex
                        class="px-2"
                        v-if="updateData.is_repackage"
                        xs12
                        sm12
                        md6
                        lg3
                      >
                        <v-text-field
                          label="Repackage Price"
                          v-model.number="updateData.repackage_price"
                          @input="calculateTotalAmount()"
                          @change="calculateTotalAmount()"
                          :error-messages="errors.collect('Repackage Price')"
                          v-validate="'decimal:2'"
                          data-vv-name="Repackage Price"
                        ></v-text-field>
                      </v-flex>

                      <v-flex
                        class="px-2"
                        v-if="updateData.is_hold"
                        xs12
                        sm12
                        md6
                        lg3
                      >
                        <v-text-field
                          label="Hold Price"
                          v-model.number="updateData.hold_price"
                          @input="calculateTotalAmount()"
                          @change="calculateTotalAmount()"
                          :error-messages="errors.collect('Hold Price')"
                          v-validate="'decimal:2'"
                          data-vv-name="Hold Price"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                -->
                <!-- end hidden: Additional Services expansion panel -->

                <!-- hidden: Select Dates section (v-if="false") -->
                <template v-if="false">
                <div class="col-md-12" style="color:#2d315c;border-bottom:1px solid #2d315c;margin-bottom:5px;">
                  <h4>Select Dates</h4>
                </div>
                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md3
                  lg4
                >
                  <date-picker
                    label="Total Amount"
                    style="margin-top: 3%; border-bottom-color: #919191;"
                    :date="startTime2"
                    :option="option2"
                    class="form-control"
                  ></date-picker>
                </v-flex>
                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md3
                  lg4
                >
                  <date-picker
                    style="margin-top: 4%; border-bottom-color: #919191"
                    :date="startTime"
                    :option="option"
                    class="form-control"
                  ></date-picker>
                  <span
                    v-if="fromDateError"
                    style="color: orangered"
                  ><br />From date must be greater than Today</span>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md3
                  lg4
                >
                  <date-picker
                    style="margin-top: 4%; border-bottom-color: #919191"
                    :date="startTime1"
                    :option="option1"
                    class="form-control"
                  ></date-picker>
                  <span
                    v-if="toDateError"
                    style="color: orangered"
                  ><br />To date must be greater than From date</span>
                </v-flex>
                </template>
                <!-- end hidden: Select Dates section -->

                <!-- <v-flex
                  class="px-2"
                  xs12
                  sm12
                  md9
                  lg6
                >
                  <v-text-field
                    label="Description"
                    v-model="updateData.description"
                  ></v-text-field>
                </v-flex> -->
                <v-layout wrap class="col-md-12">
                <!-- <v-flex
                  xs12
                  sm4
                  md4
                  lg4
                >
                  <v-select
                    :items="transportationTypes"
                    item-value="id"
                    item-text="name"
                    v-model="updateData.transportation_type"
                    :error-messages="errors.collect('Transportation Type')"
                    data-vv-name="Transportation Type"
                    label="Transportation Type*"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex> -->


              </v-layout>
                <!-- hidden: Admin Process Note (v-if="false")
                <v-flex class="px-2" xs12 sm12 md12 lg4>
                  <v-text-field label="Admin Process note" v-model="updateData.process_note"></v-text-field>
                </v-flex>
                -->
                <v-flex
                  class="px-2"
                  v-if="updateData.other_service && updateData.other_service.trim()"
                  xs12
                  sm5
                  lg4
                >
                  <v-text-field
                    :label="$t('orders.otherServiceNoteLabel')"
                    v-model="updateData.other_service"
                    data-vv-name="other_service"
                    readonly
                  >
                  </v-text-field>
                </v-flex>

                <!-- <v-flex
                  class="px-2"
                  xs12
                  sm3
                  md2
                >
                  <v-checkbox
                    style="padding: 0px"
                    label="Send SMS"
                    v-model="updateData.send_sms"
                    color="indigo"
                  ></v-checkbox>
                </v-flex> -->
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto;color: #989595;"
                @click.native="clearProcessOrderData(), (dialog = false), $validator.reset()"
                outline
                color="normal"
              >{{ $t('common.cancel') }}</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto"
                outline
                class="blue-logout rtl-mr-1-5pct"
              >{{ $t('common.save') }}</v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>

    <!-- <edit-price-for-turkey
      :edit1Modal="edit1Modal"
      :edit1Data="edit1Data"
      :closeEdit1Modal="closeEdit1Modal"
      :editPriceForTurkey="editPriceForTurkey"
      :seccessAlert="seccessAlert"
    >
    </edit-price-for-turkey>

    <edit-price-for-usa
      :edit2Modal="edit2Modal"
      :edit2Data="edit2Data"
      :closeEdit2Modal="closeEdit2Modal"
      :editPriceForUSA="editPriceForUSA"
      :seccessAlert="seccessAlert"
    >
    </edit-price-for-usa> -->

    <edit-quantity-base-usa
      :editQttBaseUSAModal="editQttBaseUSAModal"
      :editQttBaseUSAData="editQttBaseUSAData"
      :closeEditQttBaseUSAModal="closeEditQttBaseUSAModal"
      :editQttBaseUSA="editQttBaseUSA"
      :seccessAlert="seccessAlert"
    >
    </edit-quantity-base-usa>

    <edit-quantity-other-usa
      :editQttOtherUSAModal="editQttOtherUSAModal"
      :editQttOtherUSAData="editQttOtherUSAData"
      :closeEditQttOtherUSAModal="closeEditQttOtherUSAModal"
      :editQttOtherUSA="editQttOtherUSA"
      :seccessAlert="seccessAlert"
    >
    </edit-quantity-other-usa>

    <!-- <edit-quantity-base-turkey
      :editQttBaseTurkeyModal="editQttBaseTurkeyModal"
      :editQttBaseTurkeyData="editQttBaseTurkeyData"
      :closeEditQttBaseTurkeyModal="closeEditQttBaseTurkeyModal"
      :editQttBaseTurkey="editQttBaseTurkey"
      :seccessAlert="seccessAlert"
    >
    </edit-quantity-base-turkey>

    <edit-quantity-other-turkey
      :editQttOtherTurkeyModal="editQttOtherTurkeyModal"
      :editQttOtherTurkeyData="editQttOtherTurkeyData"
      :closeEditQttOtherTurkeyModal="closeEditQttOtherTurkeyModal"
      :editQttOtherTurkey="editQttOtherTurkey"
      :seccessAlert="seccessAlert"
    >
    </edit-quantity-other-turkey> -->

    <edit-delivery-type
      :deliveryTypeModal="deliveryTypeModal"
      :editDeliveryTypeData="editDeliveryTypeData"
      :closeEditDeliveryTypeModal="closeEditDeliveryTypeModal"
      :editDeliveryType="editDeliveryType"
      :seccessAlert="seccessAlert"
      :deliveryTypes="deliveryTypes"
    >
    </edit-delivery-type>

    <edit-quantity
      :quantityModal="quantityModal"
      :editQuantityData="editQuantityData"
      :closeEditQuantityModal="closeEditQuantityModal"
      :editQuantity="editQuantity"
      :seccessAlert="seccessAlert"
    >
    </edit-quantity>

    <edit-product-url
      :seccessAlert="seccessAlert"
      :editProductUrlModal="editProductUrlModal"
      :closeEditProductUrlModal="closeEditProductUrlModal"
      :editProductUrlData="editProductUrlData"
      :editProductUrl="editProductUrl"
      :UrlError="UrlError"
    ></edit-product-url>

    <edit-product-name
      :seccessAlert="seccessAlert"
      :editProductNameModal="editProductNameModal"
      :closeEditProductNameModal="closeEditProductNameModal"
      :editProductNameData="editProductNameData"
      :editProductName="editProductName"
      :UrlError="UrlError"
    ></edit-product-name>

    <edit-size
      :seccessAlert="seccessAlert"
      :editSizeModal="editSizeModal"
      :closeEditSizeModal="closeEditSizeModal"
      :editSizeData="editSizeData"
      :editSize="editSize"
    ></edit-size>

    <edit-color
      :seccessAlert="seccessAlert"
      :editColorModal="editColorModal"
      :closeEditColorModal="closeEditColorModal"
      :editColorData="editColorData"
      :editColor="editColor"
    ></edit-color>

    <edit-type
      :seccessAlert="seccessAlert"
      :editTypeModal="editTypeModal"
      :closeEditTypeModal="closeEditTypeModal"
      :editTypeData="editTypeData"
      :editType="editType"
    ></edit-type>

    <edit-transportation-type
      :form="orderObj"
      :editTransTypeModal="editTransTypeModal"
      @close="editTransTypeModal = false"
      @update-data="getResults(), updateData.transportation_type = r.transportation_type"
    />

    <v-dialog
      v-model="imgDialog"
      max-width="500px"
    >
      <v-card>
        <img
          :src="theImage && theImage.startsWith('http') ? theImage : `${$_image_path()}${theImage}`"
          :alt="$t('columns.image')"
          width="100%"
          height="100%"
          style="border-radius: 4px"
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import editPriceForTurkey from './user/editPriceForTurkey.vue'
import editPriceForUSA from './user/editPriceForUSA.vue'
import editQuantityBaseUsa from './user/editQuantityBaseUsa.vue'
import editQuantityOtherUsa from './user/editQuantityOtherUsa.vue'
import editQuantityBaseTurkey from './user/editQuantityBaseTurkey.vue'
import editQuantityOtherTurkey from './user/editQuantityOtherTurkey.vue'
import myDatepicker from 'vue-datepicker'
import editDeliveryType from './editDeliveryType.vue'
import editQuantity from './editQuantity.vue'
import editProductUrl from './editProductUrl.vue'
import editProductName from './editProductName.vue'
import editWarehouse from './editWarehouse.vue'
import editSize from './editSize.vue'
import editColor from './editColor.vue'
import editType from './editType.vue'
import axios from 'axios'
import swal from 'sweetalert'
import editTransportationType from './editTransportationType.vue'

export default {
  components: {
    'edit-price-for-turkey': editPriceForTurkey,
    'edit-price-for-usa': editPriceForUSA,
    'edit-quantity-base-usa': editQuantityBaseUsa,
    'edit-quantity-other-usa': editQuantityOtherUsa,
    'edit-quantity-base-turkey': editQuantityBaseTurkey,
    'edit-quantity-other-turkey': editQuantityOtherTurkey,
    'date-picker': myDatepicker,
    'edit-delivery-type': editDeliveryType,
    'edit-quantity': editQuantity,
    'edit-product-url': editProductUrl,
    'edit-product-name': editProductName,
    'edit-warehouse': editWarehouse,
    'edit-size': editSize,
    'edit-color': editColor,
    'edit-type': editType,
    editTransportationType
  },

  props: [
    'processOrder',
    'r',
    'checkAlert',
    'updateData',
    'calculateTotalAmount',
    'loading',
    'getResults',
    'clearProcessOrderData',
    'theQuantity',
    'itemTypes',
    'warehouses',
    'reasons'
  ],

  $_veeValidate: {
    validator: 'new'
  },

  created() {
    this.getLoggedInUser()
    let t = new Date()
    let dd = t.getDate()
    let mm = t.getMonth() + 1 // January is 0!
    let yyyy = t.getFullYear()

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    t = yyyy + '-' + mm + '-' + dd
    this.today = t
    this.startTime.time = t
    this.startTime1.time = t
  },

  data() {
    return {
      // editPriceForTurkeyUrl: 'api/change_price_per_weight_turkey',
      // editPriceForUSAUrl: 'api/change_price_per_weight_usa',
      // editQttBaseUSAUrl: 'api/change_usa_base_quantity',
      // editQttOtherUSAUrl: 'api/change_usa_other_quantity',
      // editQttBaseTurkeyUrl: 'api/change_turkey_base_quantity',
      // editQttOtherTurkeyUrl: 'api/change_turkey_other_quantity',
      editProductUrlUrl: 'api/change_product_url',
      editProductNameUrl: 'api/change_product_name',
      editWarehouseUrl: 'api/change_warehouse',
      editSizeUrl: 'api/change_size',
      editColorUrl: 'api/change_color',
      editTypeUrl: 'api/change_type',
      getActiveChangeRateUrl: 'api/get_active_exchange_rate',
      transportationTypes: [],
      activeChangeRate: [],
      orderTypes: [],
      subscription: [],
      exchangeBase: 0,
      aedExchangeBase: 0,
      cnyExchangeBase: 0,
      gbpExchangeBase: 0,
      eurExchangeBase: 0,
      tlDiscount: 0,
      aedDiscount: 0,
      cnyDiscount: 0,
      gbpDiscount: 0,
      eurDiscount: 0,
      isShipmentManual: false,
      isKreenexFeeManual: false,
      order_type_id_fk: null,
      the_user_id: '',
      seccessAlert: false,
      dialog: false,
      selectedNoteReason: null,
      has_other_service: false,
      edit1Modal: false,
      fromDateError: false,
      toDateError: false,
      editQttBaseUSAModal: false,
      editQttOtherUSAModal: false,
      // editQttBaseTurkeyModal: false,
      // editQttOtherTurkeyModal: false,
      deliveryTypeModal: false,
      quantityModal: false,
      editProductUrlModal: false,
      editProductNameModal: false,
      editWarehouseModal: false,
      editSizeModal: false,
      editColorModal: false,
      editTypeModal: false,
      UrlError: false,
      theEditOrderID: '',
      theImage: null,
      imagePreview: null,
      file: null,
      imgDialog: false,
      orderObj: {},
      editTransTypeModal: false,
      editProductUrlData: {
        product_url: ''
      },
      editProductNameData: {
        product_name: ''
      },
      editSizeData: {
        size: ''
      },
      editColorData: {
        color: ''
      },
      editTypeData: {
        type: ''
      },
      today: '',
      the_order_id: '',
      deliveryTypes: [
        { text: this.$t('orders.homeDelivery'), value: 'home delivery' },
        { text: this.$t('orders.officeDelivery'), value: 'office delivery' }
      ],
      editDeliveryTypeData: {
        delivery_type: ''
      },
      editQuantityData: {
        quantity: '',
        country: ''
      },
      loggedInUserData: {},
      temp_shipping: '',
      // edit1Data: {
      //   item_weight_price_turkey: ''
      // },
      // edit2Modal: false,
      // edit2Data: {
      //   item_weight_price_usa: ''
      // },
      editQttBaseUSAData: {
        quantity_charge_base_usa: '',
        order_id: ''
      },
      // editQttBaseTurkeyData: {
      //   quantity_charge_base_turkey: '',
      //   order_id: ''
      // },
      editQttOtherUSAData: {
        quantity_charge_other_usa: '',
        order_id: ''
      },
      // editQttOtherTurkeyData: {
      //   quantity_charge_other_turkey: '',
      //   order_id: ''
      // },
      startTime: {
        time: ''
      },
      startTime1: {
        time: ''
      },
      startTime2: {
        time: ''
      },
      option: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'From Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option1: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'To Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      option2: {
        type: 'day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD',
        placeholder: 'Warehouse Date',
        inputStyle: {
          display: 'inline-block',
          padding: '6px',
          'line-height': '22px',
          'font-size': '16px',
          color: '#2d2d2d'
        },
        color: {
          header: '#5a5bcc',
          headerText: '#f4fff5'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      timeoption: {
        type: 'min',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD HH:mm'
      },
      multiOption: {
        type: 'multi-day',
        week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
        month: [
          'January',
          'February',
          'March',
          'April',
          'May',
          'June',
          'July',
          'August',
          'September',
          'October',
          'November',
          'December'
        ],
        format: 'YYYY-MM-DD HH:mm'
      },
      panel: null,
      // Phase 5 additions
      customers: [],
      estimateDays: 7,
      localDeliveryIqd: 0,
      orderImagePreview: null,
      orderImageName: ''
    }
  },

  computed: {
    // UK is priced in USD now. Only UK orders created while it was still GBP carry a
    // the_gbp_price, and those keep the £ fields so their GBP cost stays consistent.
    isGbpPricedOrder() {
      return !!this.r && this.r.country === 'United Kingdom' && Number(this.r.the_gbp_price) > 0
    },
    warehouseCurrencySymbol() {
      if (!this.r || !this.r.country) return '$'
      const c = this.r.country.toLowerCase()
      if (c === 'turkey') return '₺'
      return '$'
    },
    caculatePurchaseCost() {
      const qtt = Number(this.updateData.quantity) || Number(this.theQuantity.quantity) || Number(this.r.quantity) || 0
      const item = Number(this.updateData.item_price) || 0
      const ship = Number(this.updateData.internal_shipping_handling) || 0
      return Number((item + ship) * qtt +
             Number(this.updateData.national_tax) +
             Number(this.updateData.delivery_price)).toFixed(2)
    },
    selectedOrderTypePrice() {
      if (!this.subscription || !this.r.transportation_type_obj || this.r.transportation_type_obj.id === null) {
        return '0.00'
      }

      switch (this.r.transportation_type_obj.id) {
        case 1: // Air
          return this.subscription.item_price_air || '0.00'
        case 2: // Sea
          return this.subscription.item_price_sea || '0.00'
        default: // Land
          return this.subscription.item_price_land || '0.00'
      }
    }
  },

  watch: {
    dialog(val) {
      if (val) {
        // Single-instance pattern (purchasedOrder/approvedOrder/allOrder.vue) reuses this
        // component across every order in the list without destroying it, so a stray
        // validation error left over from a previous order's "Int. Shipping" field would
        // otherwise stick around and show up on the next order even with a valid value.
        this.$validator.reset()
        this.updateData.transportation_type = this.r.transportation_type
        this.updateData.is_repackage = this.r.is_repackage
        this.updateData.is_hold = this.r.is_hold
        this.updateData.other_service = this.r.other_service
        this.has_other_service = !!(this.r.other_service && this.r.other_service.trim())
        this.transportationTypes = this.r.warehouse.transportation_types
        // Auto-select first transportation type
        if (this.transportationTypes && this.transportationTypes.length > 0) {
          this.r.transportation_type = this.transportationTypes[0].id
          this.updateData.transportation_type = this.transportationTypes[0].id
        }
        this.getOrderTypes()
        // Phase 5: pre-fill new editable fields
        this.updateData.customer_id_fk = this.r.user_id
        this.updateData.product_name = this.r.product_name
        this.updateData.product_url = this.r.product_url
        this.updateData.quantity = this.r.quantity
        this.updateData.color = this.r.color
        this.updateData.size = this.r.size
        this.updateData.note = this.r.note
        this.updateData.brand = this.r.brand || null
        // Pre-fill item_price from existing order data
        this.updateData.item_price = this.r.item_price || ''
        this.updateData.the_tl_price = this.r.the_tl_price || ''
        this.updateData.the_aed_price = this.r.the_aed_price || ''
        this.updateData.the_cny_price = this.r.the_cny_price || ''
        this.updateData.the_gbp_price = this.r.the_gbp_price || ''
        this.updateData.the_eur_price = this.r.the_eur_price || ''
        this.updateData.internal_shipping_handling = this.r.internal_shipping_handling || ''
        this.isShipmentManual = !!(this.r.internal_shipping_handling && Number(this.r.internal_shipping_handling) > 0)
        this.updateData.kreenex_fee = this.r.kreenex_fee || 0
        this.isKreenexFeeManual = true
        this.updateData.local_delivery = Number(this.r.local_delivery) || 0
        // local_delivery is stored as IQD directly, no conversion needed
        this.localDeliveryIqd = Number(this.r.local_delivery) || 0
        this.estimateDays = this.resolveEstimateDays()
        this.onEstimateDaysChange()
        this.updateData.national_tax = this.r.national_tax || 0
        this.updateData.discount = this.r.discount || 0
        // Back-convert discount for Turkey/UAE display if rate already loaded
        if (this.r.country === 'Turkey' && this.exchangeBase > 0) {
          this.tlDiscount = Number(((this.r.discount || 0) * this.exchangeBase).toFixed(2))
        } else {
          this.tlDiscount = 0
        }
        if (this.r.country === 'UAE' && this.aedExchangeBase > 0) {
          this.aedDiscount = Number(((this.r.discount || 0) * this.aedExchangeBase).toFixed(2))
        } else {
          this.aedDiscount = 0
        }
        if (this.r.country === 'China' && this.cnyExchangeBase > 0) {
          this.cnyDiscount = Number(((this.r.discount || 0) * this.cnyExchangeBase).toFixed(2))
        } else {
          this.cnyDiscount = 0
        }
        if (this.isGbpPricedOrder && this.gbpExchangeBase > 0) {
          this.gbpDiscount = Number(((this.r.discount || 0) * this.gbpExchangeBase).toFixed(2))
        } else {
          this.gbpDiscount = 0
        }
        if (this.r.country === 'Germany' && this.eurExchangeBase > 0) {
          this.eurDiscount = Number(((this.r.discount || 0) * this.eurExchangeBase).toFixed(2))
        } else {
          this.eurDiscount = 0
        }
        this.orderImagePreview = null
        this.orderImageName = ''
        this.getCustomers()
      }
    },
    'has_other_service'(val) {
      if (!val && !this.updateData.other_service) {
        // Clear other service price when checkbox is unchecked and there's no existing other service data
        this.updateData.other_service_price = 0
        this.calculateTotalAmount()
      }
    },
    selectedOrderTypePrice(newPrice) {
      if (newPrice && newPrice !== '0.00') {
        this.updateData.price_weight = newPrice
        this.calculateTotalAmount()
      }
    }
  },

  methods: {
    showImage(img) {
      this.theImage = img
      this.imgDialog = true
    },

    triggerFileInput() {
      this.$refs.fileInput.click()
    },

    insertReasonIntoNote() {
      if (!this.selectedNoteReason) return
      const reasonObj = (this.reasons || []).find(r => r.value === this.selectedNoteReason)
      if (!reasonObj) return
      const lines = [reasonObj.text, reasonObj.ar, reasonObj.ku].filter(line => line)
      this.updateData.customer_process_note = lines.join('\n')
    },

    handleFileUpload(event) {
      this.updateData.customer_process_note_image = null
      this.updateData.fileName = ''
      this.$validator.errors.remove('file')
      const file = event.target.files[0]
      if (file && !this.errors.has('file')) {
        this.file = file
        this.updateData.customer_process_note_image = file
        this.updateData.fileName = file.name
        this.imagePreview = URL.createObjectURL(file)
      } else {
        this.file = null
        this.updateData.customer_process_note_image = null
        this.imagePreview = null
      }
    },

    // calculateUSDPrice(tlPrice, country) {
    //   let usdPrice = tlPrice / this.exchangeBase
    //   usdPrice = Number(usdPrice).toFixed(2)
    //   this.updateData.item_price = usdPrice

    //   this.calculateShipzoneFee(
    //     this.updateData.item_price,
    //     this.defaultPriceData.kreenex_fee_percentage,
    //     country
    //   )
    //   this.calculateTotalAmount()
    // },

    // calculateUSDPrice re-enabled for Turkey TL → USD conversion
    calculateUSDPrice(tlPrice) {
      if (this.exchangeBase && Number(this.exchangeBase) > 0) {
        this.updateData.item_price = Number(tlPrice / this.exchangeBase).toFixed(4)
      }
      this.calculateIntShipping()
      this.calculateTotalAmount()
    },

    setDiscountFromTL() {
      if (this.exchangeBase && Number(this.exchangeBase) > 0 && this.tlDiscount) {
        this.updateData.discount = Number(this.tlDiscount / this.exchangeBase).toFixed(4)
      } else {
        this.updateData.discount = this.tlDiscount
      }
      this.calculateTotalAmount()
    },

    setDiscountFromAED() {
      if (this.aedExchangeBase && Number(this.aedExchangeBase) > 0 && this.aedDiscount) {
        this.updateData.discount = Number(this.aedDiscount / this.aedExchangeBase).toFixed(4)
      } else {
        this.updateData.discount = this.aedDiscount
      }
      this.calculateTotalAmount()
    },

    calculateAEDPrice(aedPrice) {
      if (this.aedExchangeBase && Number(this.aedExchangeBase) > 0) {
        this.updateData.item_price = Number(aedPrice / this.aedExchangeBase).toFixed(4)
      }
      this.calculateIntShipping()
      this.calculateTotalAmount()
    },

    getAEDRate() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          if (response.data && response.data.aed_rate > 0) {
            this.aedExchangeBase = response.data.aed_rate
            // Back-convert saved discount to AED once rate is loaded
            if (this.dialog && this.r.country === 'UAE') {
              this.aedDiscount = Number(((this.updateData.discount || 0) * this.aedExchangeBase).toFixed(2))
            }
          }
        })
    },

    getExchangeRate() {
      let token = localStorage.getItem('access_token')

      axios
        .get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          if (response.data && response.data.tl_rate > 0) {
            this.exchangeBase = response.data.tl_rate
            // Back-convert saved discount to TL once rate is loaded
            if (this.dialog && this.r.country === 'Turkey') {
              this.tlDiscount = Number(((this.updateData.discount || 0) * this.exchangeBase).toFixed(2))
            }
          }
        })
    },

    getCNYRate() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          if (response.data && response.data.cny_rate > 0) {
            this.cnyExchangeBase = response.data.cny_rate
            if (this.dialog && this.r.country === 'China') {
              this.cnyDiscount = Number(((this.updateData.discount || 0) * this.cnyExchangeBase).toFixed(2))
            }
          }
        })
    },

    calculateCNYPrice(cnyPrice) {
      if (this.cnyExchangeBase && Number(this.cnyExchangeBase) > 0) {
        this.updateData.item_price = Number(cnyPrice / this.cnyExchangeBase).toFixed(4)
      }
      this.calculateIntShipping()
      this.calculateTotalAmount()
    },

    setDiscountFromCNY() {
      if (this.cnyExchangeBase && Number(this.cnyExchangeBase) > 0 && this.cnyDiscount) {
        this.updateData.discount = Number(this.cnyDiscount / this.cnyExchangeBase).toFixed(4)
      } else {
        this.updateData.discount = this.cnyDiscount
      }
      this.calculateTotalAmount()
    },

    getGBPRate() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          if (response.data && response.data.gbp_rate > 0) {
            this.gbpExchangeBase = response.data.gbp_rate
            if (this.dialog && this.isGbpPricedOrder) {
              this.gbpDiscount = Number(((this.updateData.discount || 0) * this.gbpExchangeBase).toFixed(2))
            }
          }
        })
    },

    calculateGBPPrice(gbpPrice) {
      if (this.gbpExchangeBase && Number(this.gbpExchangeBase) > 0) {
        this.updateData.item_price = Number(gbpPrice / this.gbpExchangeBase).toFixed(4)
      }
      this.calculateIntShipping()
      this.calculateTotalAmount()
    },

    setDiscountFromGBP() {
      if (this.gbpExchangeBase && Number(this.gbpExchangeBase) > 0 && this.gbpDiscount) {
        this.updateData.discount = Number(this.gbpDiscount / this.gbpExchangeBase).toFixed(4)
      } else {
        this.updateData.discount = this.gbpDiscount
      }
      this.calculateTotalAmount()
    },

    getEURRate() {
      let token = localStorage.getItem('access_token')
      axios
        .get('api/currency-rate/latest', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          if (response.data && response.data.eur_rate > 0) {
            this.eurExchangeBase = response.data.eur_rate
            if (this.dialog && this.r.country === 'Germany') {
              this.eurDiscount = Number(((this.updateData.discount || 0) * this.eurExchangeBase).toFixed(2))
            }
          }
        })
    },

    calculateEURPrice(eurPrice) {
      if (this.eurExchangeBase && Number(this.eurExchangeBase) > 0) {
        this.updateData.item_price = Number(eurPrice / this.eurExchangeBase).toFixed(4)
      }
      this.calculateIntShipping()
      this.calculateTotalAmount()
    },

    setDiscountFromEUR() {
      if (this.eurExchangeBase && Number(this.eurExchangeBase) > 0 && this.eurDiscount) {
        this.updateData.discount = Number(this.eurDiscount / this.eurExchangeBase).toFixed(4)
      } else {
        this.updateData.discount = this.eurDiscount
      }
      this.calculateTotalAmount()
    },

    convertLbToKg() {
      if (this.updateData.item_weight_lb && this.updateData.item_weight_lb > 0) {
        // Convert LB to KG (1 pound = 0.453592 kg)
        const kgValue = this.updateData.item_weight_lb * 0.4545
        this.updateData.item_weight = Number(kgValue.toFixed(4))

        // Trigger the calculations that depend on weight
        this.calculateIntShipping()
        this.calculateTotalAmount()
      }
    },

    openEditProductUrlModal(url, orderID) {
      this.theEditOrderID = orderID
      this.editProductUrlData.product_url = url
      this.editProductUrlModal = true
    },

    openEditProductNameModal(name, orderID) {
      this.theEditOrderID = orderID
      this.editProductNameData.product_name = name
      this.editProductNameModal = true
    },

    closeEditProductUrlModal() {
      this.editProductUrlData.product_url = ''
      this.editProductUrlModal = false
      this.UrlError = false
      this.seccessAlert = false
    },

    closeEditProductNameModal() {
      this.editProductNameData.product_name = ''
      this.editProductNameModal = false
      this.NameError = false
      this.seccessAlert = false
    },

    editProductUrl() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.editProductUrlUrl + '/' + this.theEditOrderID, this.editProductUrlData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.UrlError = false
          this.seccessAlert = true
          setTimeout(() => {
            this.closeEditProductUrlModal()
          }, 1500)
          this.getResults()
        })
        .catch((error) => {
          this.seccessAlert = false
          if (error.response.data.message.product_url) {
            this.UrlError = true
          }
        })
    },

    editProductName() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.editProductNameUrl + '/' + this.theEditOrderID, this.editProductNameData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.UrlError = false
          this.seccessAlert = true
          setTimeout(() => {
            this.closeEditProductUrlModal()
          }, 1500)
          this.getResults()
        })
        .catch((error) => {
          this.seccessAlert = false
          if (error.response.data.message.product_name) {
            this.NameError = true
          }
        })
    },

    openEditTransportationTypeModal(order) {
      this.orderObj = order
      this.editTransTypeModal = true
    },

    openEditWarehouseModal(warehouse, orderID) {
      this.theEditOrderID = orderID
      this.editWarehouseData.warehouse_id_fk = warehouse
      this.editWarehouseModal = true
    },

    closeEditWarehouseModal() {
      this.theEditOrderID = ''
      this.editWarehouseData.warehouse_id_fk = ''
      this.editWarehouseModal = false
      this.seccessAlert = false
    },

    editWarehouse(orderId, warehouseIdFk) {
      let token = localStorage.getItem('access_token')

      // Use the raw value from whichever currency field is currently visible.
      // This preserves the number the admin actually typed (e.g. 500) as the
      // USD item_price after warehouse change, rather than any exchange-rate
      // derivative (e.g. 500 TL ÷ rate ≈ 16.67).
      const activeRawPrice = (() => {
        const c = this.r.country
        if (c === 'Turkey' && this.updateData.the_tl_price != null && this.updateData.the_tl_price !== '')
          return this.updateData.the_tl_price
        if (c === 'UAE' && this.updateData.the_aed_price != null && this.updateData.the_aed_price !== '')
          return this.updateData.the_aed_price
        if (c === 'China' && this.updateData.the_cny_price != null && this.updateData.the_cny_price !== '')
          return this.updateData.the_cny_price
        if (c === 'United Kingdom' && this.updateData.the_gbp_price != null && this.updateData.the_gbp_price !== '')
          return this.updateData.the_gbp_price
        if (c === 'Germany' && this.updateData.the_eur_price != null && this.updateData.the_eur_price !== '')
          return this.updateData.the_eur_price
        return this.updateData.item_price
      })()

      const priceSnapshot = {
        item_price: activeRawPrice,
        the_tl_price: this.updateData.the_tl_price,
        the_aed_price: this.updateData.the_aed_price,
        the_cny_price: this.updateData.the_cny_price,
        the_gbp_price: this.updateData.the_gbp_price,
        the_eur_price: this.updateData.the_eur_price
      }

      axios
        .put(this.editWarehouseUrl + '/' + orderId, { warehouse_id_fk: warehouseIdFk }, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then(() => {
          this.seccessAlert = true
          const wh = this.warehouses && this.warehouses.find(w => w.value === warehouseIdFk)
          if (wh && wh.estimate_days != null && wh.estimate_days !== '') {
            const en = Number(wh.estimate_days)
            if (en > 0) {
              this.estimateDays = en
            }
          }
          this.recalcDatesFromEstimate()
          this.getResults()
          this.getOrderTypes(priceSnapshot)
        }).then(() => {
          setTimeout(() => {
            this.transportationTypes = this.r.warehouse.transportation_types
            if (this.transportationTypes && this.transportationTypes.length > 0) {
              this.r.transportation_type = this.transportationTypes[0].id
              this.updateData.transportation_type = this.transportationTypes[0].id
              this.editTransportationTypeSave(this.r.order_id, this.transportationTypes[0].id)
            }
            this.order_type_id_fk = null
          }, 1000)
        })
    },

    editTransportationTypeSave(orderId, transportationType) {
      let token = localStorage.getItem('access_token')

      axios.put(`api/order/${orderId}/change-transportation-type`, { transportation_type: transportationType }, { headers: { Authorization: 'Bearer ' + token } })
        .then(() => {
          this.getResults()
          this.order_type_id_fk = null
          this.updateData.transportation_type = transportationType
        })
    },

    openEditSizeModal(size, orderID) {
      this.theEditOrderID = orderID
      this.editSizeData.size = size
      this.editSizeModal = true
    },

    closeEditSizeModal() {
      this.theEditOrderID = ''
      this.editSizeData.size = ''
      this.editSizeModal = false
      this.seccessAlert = false
    },

    editSize() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.editSizeUrl + '/' + this.theEditOrderID, this.editSizeData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.getResults()
        })
    },

    openEditColorModal(color, orderID) {
      this.theEditOrderID = orderID
      this.editColorData.color = color
      this.editColorModal = true
    },

    openEditTypeModal(type, orderID) {
      this.theEditOrderID = orderID
      this.editTypeData.type = type
      this.editTypeModal = true
    },

    closeEditColorModal() {
      this.theEditOrderID = ''
      this.editColorData.size = ''
      this.editColorModal = false
      this.seccessAlert = false
    },

    editColor() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.editColorUrl + '/' + this.theEditOrderID, this.editColorData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.getResults()
        })
    },

    closeEditTypeModal() {
      this.theEditOrderID = ''
      this.editTypeData.type = ''
      this.editTypeModal = false
      this.seccessAlert = false
    },

    editType() {
      let token = localStorage.getItem('access_token')

      axios
        .put(this.editTypeUrl + '/' + this.theEditOrderID, this.editTypeData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.getResults()
        })
    },

    openEditQuantityModal(orderId) {
      this.quantityModal = true
      this.the_order_id = orderId
    },

    closeEditQuantityModal() {
      this.quantityModal = false
      this.editQuantityData.quantity = ''
      this.editQuantityData.country = ''
      this.seccessAlert = false
    },

    editQuantity() {
      this.editQuantityData.country = this.r.country
      let token = localStorage.getItem('access_token')
      axios
        .put('api/orders/' + this.the_order_id + '/quantity', this.editQuantityData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.updateData.quantity_charge = response.data.data.quantity_charge
          this.theQuantity.quantity = response.data.data.quantity
          this.calculateTotalAmount()
          this.seccessAlert = true
          this.editQuantityData.quantity = ''
          this.editQuantityData.country = ''
          this.the_order_id = ''
          this.getResults()
        })
        .catch(() => {
          this.editQuantityData.quantity = ''
          this.editQuantityData.country = ''
          this.the_order_id = ''
        })
    },

    openEditDeliveryTypeModal(orderId) {
      this.deliveryTypeModal = true
      this.the_order_id = orderId
    },

    closeEditDeliveryTypeModal() {
      this.deliveryTypeModal = false
      this.editDeliveryTypeData.delivery_type = ''
      this.seccessAlert = false
    },

    editDeliveryType() {
      let token = localStorage.getItem('access_token')
      axios
        .put('api/orders/' + this.the_order_id + '/delivery_type', this.editDeliveryTypeData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.editDeliveryTypeData.delivery_type = ''
          this.the_order_id = ''
          this.getResults()
        })
        .catch(() => {
          this.editDeliveryTypeData.delivery_type = ''
          this.the_order_id = ''
        })
    },

    // calculateIntShipping(warehouse, coupon, percentage, priceForTurkey, priceForUsa, qtt) {
    //   if (coupon) {
    //     if (warehouse.toLowerCase() === 'turkey') {
    //       let shippingPrice2 = 0
    //       this.temp_shipping = (priceForTurkey * this.updateData.item_weight).toFixed(2)
    //       shippingPrice2 = this.temp_shipping - (this.temp_shipping * percentage) / 100
    //       shippingPrice2 = shippingPrice2 * qtt
    //       this.updateData.internal_shipping_handling = shippingPrice2.toFixed(2)
    //     } else {
    //       let shippingPrice1 = 0
    //       this.temp_shipping = (priceForUsa * this.updateData.item_weight).toFixed(2)
    //       shippingPrice1 = this.temp_shipping - (this.temp_shipping * percentage) / 100
    //       shippingPrice1 = shippingPrice1 * qtt
    //       this.updateData.internal_shipping_handling = shippingPrice1.toFixed(2)
    //     }
    //   } else {
    //     if (warehouse.toLowerCase() === 'turkey') {
    //       let shipPrice1 = priceForTurkey * this.updateData.item_weight
    //       shipPrice1 = shipPrice1 * qtt
    //       shipPrice1 = Number(shipPrice1).toFixed(2)
    //       this.updateData.internal_shipping_handling = shipPrice1
    //       this.temp_shipping = shipPrice1
    //     } else {
    //       let shipPrice = priceForUsa * this.updateData.item_weight
    //       shipPrice = shipPrice * qtt
    //       shipPrice = Number(shipPrice).toFixed(2)
    //       this.updateData.internal_shipping_handling = shipPrice
    //       this.temp_shipping = shipPrice
    //     }
    //   }
    // },

    // calculateIntShipping2(tmp, warehouse, coupon, percentage, priceForTurkey, priceForUsa, qtt) {
    //   if (coupon) {
    //     if (warehouse.toLowerCase() === 'turkey') {
    //       let shippingPrice2 = 0
    //       shippingPrice2 = tmp
    //       shippingPrice2 = shippingPrice2 - (shippingPrice2 * percentage) / 100
    //       shippingPrice2 = shippingPrice2 * qtt
    //       this.updateData.internal_shipping_handling = shippingPrice2.toFixed(2)
    //     } else {
    //       let shippingPrice1 = 0
    //       shippingPrice1 = tmp
    //       shippingPrice1 = shippingPrice1 - (shippingPrice1 * percentage) / 100
    //       shippingPrice1 = shippingPrice1 * qtt
    //       this.updateData.internal_shipping_handling = shippingPrice1.toFixed(2)
    //     }
    //   } else {
    //     if (warehouse.toLowerCase() === 'turkey') {
    //       let shipPrice1 = priceForTurkey * this.updateData.item_weight
    //       shipPrice1 = shipPrice1 * qtt
    //       shipPrice1 = Number(shipPrice1).toFixed(2)
    //       this.updateData.internal_shipping_handling = shipPrice1
    //       this.temp_shipping = shipPrice1
    //     } else {
    //       let shipPrice = priceForUsa * this.updateData.item_weight
    //       shipPrice = shipPrice * qtt
    //       shipPrice = Number(shipPrice).toFixed(2)
    //       this.updateData.internal_shipping_handling = shipPrice
    //       this.temp_shipping = shipPrice
    //     }
    //   }
    // },

    // calculateIntShipping3(coupon, percentage, itemType, qtt) {
    //   let itemTypeShippingPrice = 0

    //   let k = this.itemTypes.findIndex((item) => item.value === itemType)
    //   itemTypeShippingPrice = this.itemTypes[k].shippingPrice

    //   itemTypeShippingPrice = Number(itemTypeShippingPrice)

    //   if (coupon) {
    //     let shippingPrice3 = 0
    //     this.temp_shipping = itemTypeShippingPrice.toFixed(2)
    //     shippingPrice3 = this.temp_shipping - (this.temp_shipping * percentage) / 100
    //     shippingPrice3 = shippingPrice3 * qtt
    //     this.updateData.internal_shipping_handling = shippingPrice3.toFixed(2)
    //   } else {
    //     let shipPrice = itemTypeShippingPrice
    //     shipPrice = shipPrice * qtt
    //     shipPrice = Number(shipPrice)
    //     this.updateData.internal_shipping_handling = shipPrice
    //     this.temp_shipping = shipPrice
    //   }
    // },

    // calculateShipzoneFee(itemPrice, percentage, country) {
    //   percentage = Number(percentage)
    //   if (itemPrice < this.defaultPriceData.kreenex_fee_base_usa && itemPrice > 0) {
    //     this.updateData.kreenex_fee = this.defaultPriceData.kreenex_fee_usa.toFixed(2)
    //   } else {
    //     this.updateData.kreenex_fee = (
    //       this.defaultPriceData.kreenex_fee_usa +
    //       itemPrice * percentage
    //     ).toFixed(2)
    //   }
    // },

    getLoggedInUser() {
      this.loggedInUserData = JSON.parse(localStorage.getItem('user_data'))
    },

    // Phase 5: new methods
    getCustomers() {
      this.customers = []
      const token = localStorage.getItem('access_token')
      axios
        .get('api/get-customer-to-select', { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          response.data.data.forEach((c) => {
            this.customers.push({
              text: c.full_name + ' - Tel: ' + [c.phone_number, c.phone_number_2].filter(Boolean).join(' / '),
              value: c.user_id
            })
          })
        })
    },

    resolveEstimateDays() {
      const row = this.r.warehouse && this.r.warehouse.estimate_days
      if (row != null && row !== '') {
        const n = Number(row)
        if (n > 0) {
          return n
        }
      }
      const wh = this.warehouses && this.warehouses.find(w => w.value === this.r.warehouse_id_fk)
      if (wh && wh.estimate_days != null && wh.estimate_days !== '') {
        const n = Number(wh.estimate_days)
        if (n > 0) {
          return n
        }
      }
      return 7
    },

    recalcDatesFromEstimate() {
      const n = Number(this.estimateDays)
      if (!n || n <= 0 || !this.startTime || !this.startTime.time) {
        return
      }
      const parts = String(this.startTime.time).trim().split(/[-T]/)
      const y = parseInt(parts[0], 10)
      const mo = parseInt(parts[1], 10)
      const d = parseInt(parts[2], 10)
      if (!y || !mo || !d) {
        return
      }
      const fromDate = new Date(y, mo - 1, d)
      if (isNaN(fromDate.getTime())) {
        return
      }
      const toDate = new Date(fromDate)
      toDate.setDate(toDate.getDate() + n)
      const dd = String(toDate.getDate()).padStart(2, '0')
      const mm = String(toDate.getMonth() + 1).padStart(2, '0')
      this.startTime1.time = `${toDate.getFullYear()}-${mm}-${dd}`
    },

    onEstimateDaysChange() {
      const n = Number(this.estimateDays)
      if (!n || n <= 0) {
        return
      }
      const today = new Date()
      const fromDate = new Date(today)
      fromDate.setDate(fromDate.getDate() + 1)
      const fmt = (date) => {
        const dd = String(date.getDate()).padStart(2, '0')
        const mm = String(date.getMonth() + 1).padStart(2, '0')
        return `${date.getFullYear()}-${mm}-${dd}`
      }
      this.startTime.time = fmt(fromDate)
      this.recalcDatesFromEstimate()
    },

    onLocalDeliveryIqdChange() {
      this.updateData.local_delivery = this.localDeliveryIqd
      this.calculateTotalAmount()
    },

    triggerOrderImageInput() {
      this.$refs.orderImageInput.click()
    },

    handleOrderImageUpload(event) {
      const file = event.target.files[0]
      if (file) {
        this.updateData.order_image = file
        this.orderImageName = file.name
        this.orderImagePreview = URL.createObjectURL(file)
      }
    },

    submitOrder(event, id) {
      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.estimateDays && Number(this.estimateDays) > 0) {
            // Dates already set by onEstimateDaysChange — skip from_date > today check
            this.toDateError = false
            this.fromDateError = false
            this.updateData.from_date = this.startTime.time
            this.updateData.to_date = this.startTime1.time
            this.updateData.warehouse_date = this.startTime2.time
            this.updateData.tmp_shipping = this.temp_shipping
            this.temp_shipping = ''
            this.dialog = false
            this.processOrder(event, id, this.startTime, this.startTime1, this.startTime2)
          } else if (this.startTime.time <= this.today) {
            this.toDateError = false
            this.fromDateError = true
          } else if (this.startTime1.time <= this.startTime.time) {
            this.fromDateError = false
            this.toDateError = true
          } else {
            this.toDateError = false
            this.fromDateError = false
            this.updateData.from_date = this.startTime.time
            this.updateData.to_date = this.startTime1.time
            this.updateData.warehouse_date = this.startTime2.time
            this.updateData.tmp_shipping = this.temp_shipping
            this.temp_shipping = ''
            this.dialog = false
            this.processOrder(event, id, this.startTime, this.startTime1, this.startTime2)
          }
        }
      })
    },

    openEdit1Modal(id) {
      this.edit1Modal = true
      this.the_user_id = id
    },

    closeEdit1Modal() {
      this.edit1Modal = false
      // this.edit1Data.item_weight_price_turkey = ''
      this.seccessAlert = false
    },

    getOrderTypes(priceSnapshot = null) {
      let token = localStorage.getItem('access_token')
      axios
        .get(`api/subscription-pricing/get-order-types/` + this.r.warehouse_id_fk, { headers: { Authorization: 'Bearer ' + token } })
        .then((response) => {
          let result = response.data.data
          this.getCustomerPriceList(priceSnapshot)
          this.orderTypes = [] // Clear existing order types
          result.forEach((r) => {
            this.orderTypes.push({
              text: r.type_name,
              value: r.order_type_id,
              type_price_air: r.type_price_air,
              type_price_sea: r.type_price_sea,
              type_price_land: r.type_price_land
            })
          })
        })
    },

    getCustomerPriceList(priceSnapshot = null) {
      var token = localStorage.getItem('access_token')
      let params = {
        customer_id_fk: this.r.user_id,
        warehouse_id_fk: this.r.warehouse_id_fk,
        order_type_id_fk: this.order_type_id_fk
      }
      axios
        .post('api/subscription-pricing/customer-price', params, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          let data = response.data
          this.subscription = data.data
          this.calculateIntShipping()
          if (priceSnapshot) {
            Object.assign(this.updateData, priceSnapshot)
          }
        })
        .catch((errors) => { })
        .finally(() => {
          this.calculateTotalAmount()
        })
    },

    applyShippingDiscount() {
      const pct = Number(this.r.percentage) || 0
      const raw = Number(this.temp_shipping) || 0
      if (pct > 0 && raw > 0) {
        this.updateData.internal_shipping_handling = (raw - raw * pct / 100).toFixed(2)
      } else {
        this.updateData.internal_shipping_handling = raw.toFixed(2)
      }
      this.calculateTotalAmount()
    },

    calculateIntShipping() {
      if (!this.subscription) return
      const transTypeId = this.r.transportation_type_obj ? this.r.transportation_type_obj.id : (this.r.transportation_type || null)
      if (!this.isKreenexFeeManual) {
        this.updateData.kreenex_fee = (Number(this.updateData.item_price) <= 0 ? 0 : 0.5 * this.subscription.order_shipzone_fee * (Math.floor(this.caculatePurchaseCost / 50) + 1)).toFixed(2)
      }
      if (!this.isShipmentManual) {
        const qForShip = Number(this.updateData.quantity) || Number(this.r.quantity) || 0
        this.updateData.internal_shipping_handling = ((transTypeId === 1 ? this.subscription.item_price_air * Number(this.updateData.item_weight)
          : transTypeId === 2 ? this.subscription.item_price_sea * Number(this.updateData.item_weight)
            : this.subscription.item_price_land * Number(this.updateData.item_weight)) * qForShip).toFixed(2)
      }
      this.calculateTotalAmount()
    },

    // editPriceForTurkey() {
    //   let token = localStorage.getItem('access_token')
    //   axios
    //     .put(this.editPriceForTurkeyUrl + '/' + this.the_user_id, this.edit1Data, {
    //       headers: { Authorization: 'Bearer ' + token }
    //     })
    //     .then((response) => {
    //       this.seccessAlert = true
    //       // this.edit1Data.item_weight_price_turkey = ''
    //       this.getResults()
    //     })
    //     .catch((error) => {
    //       // this.edit1Data.item_weight_price_turkey = ''
    //       swal('Error', `${error.response.data.message}`, 'error')
    //     })
    // },

    handleOrderTypeChange() {
      this.isShipmentManual = false
      this.isHandlingFeeManual = false
      this.isKreenexFeeManual = false
      this.getCustomerPriceList()
    },

    openEdit2Modal(id) {
      this.edit2Modal = true
      this.the_user_id = id
    },

    closeEdit2Modal() {
      this.edit2Modal = false
      // this.edit2Data.item_weight_price_usa = ''
      this.seccessAlert = false
    },

    editPriceForUSA() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.editPriceForUSAUrl + '/' + this.the_user_id, this.edit2Data, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          // this.edit2Data.item_weight_price_usa = ''
          this.getResults()
        })
        .catch((error) => {
          // this.edit2Data.item_weight_price_usa = ''
          swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
        })
    },

    openEditQttBaseUSAModal(id, orderId) {
      this.editQttBaseUSAModal = true
      this.the_user_id = id
      this.editQttBaseUSAData.order_id = orderId
    },

    closeEditQttBaseUSAModal() {
      this.editQttBaseUSAModal = false
      this.editQttBaseUSAData.quantity_charge_base_usa = ''
      this.seccessAlert = false
    },

    editQttBaseUSA() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.editQttBaseUSAUrl + '/' + this.the_user_id, this.editQttBaseUSAData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.editQttBaseUSAData.quantity_charge_base_usa = ''
          this.getResults()
          let a = this
          setTimeout(function () {
            a.updateData.quantity_charge = a.r.quantity_charge
            a.calculateTotalAmount()
          }, 1000)
        })
        .catch((error) => {
          this.editQttBaseUSAData.quantity_charge_base_usa = ''
          swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
        })
    },

    openEditQttOtherUSAModal(id, orderId) {
      this.editQttOtherUSAModal = true
      this.the_user_id = id
      this.editQttOtherUSAData.order_id = orderId
    },

    closeEditQttOtherUSAModal() {
      this.editQttOtherUSAModal = false
      this.editQttOtherUSAData.quantity_charge_base_usa = ''
      this.seccessAlert = false
    },

    editQttOtherUSA() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.editQttOtherUSAUrl + '/' + this.the_user_id, this.editQttOtherUSAData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.editQttOtherUSAData.quantity_charge_base_usa = ''
          this.getResults()
          let a = this
          setTimeout(function () {
            a.updateData.quantity_charge = a.r.quantity_charge
            a.calculateTotalAmount()
          }, 1000)
        })
        .catch((error) => {
          this.editQttOtherUSAData.quantity_charge_base_usa = ''
          swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
        })
    },

    openEditQttBaseTurkeyModal(id, orderId) {
      this.editQttBaseTurkeyModal = true
      this.the_user_id = id
      this.editQttBaseTurkeyData.order_id = orderId
    },

    closeEditQttBaseTurkeyModal() {
      this.editQttBaseTurkeyModal = false
      this.editQttBaseTurkeyData.quantity_charge_base_turkey = ''
      this.seccessAlert = false
    },

    editQttBaseTurkey() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.editQttBaseTurkeyUrl + '/' + this.the_user_id, this.editQttBaseTurkeyData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.editQttBaseTurkeyData.quantity_charge_base_turkey = ''
          this.getResults()
          let a = this
          setTimeout(function () {
            a.updateData.quantity_charge = a.r.quantity_charge
            a.calculateTotalAmount()
          }, 1000)
        })
        .catch((error) => {
          this.editQttBaseTurkeyData.quantity_charge_base_turkey = ''
          swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
        })
    },

    openEditQttOtherTurkeyModal(id, orderId) {
      this.editQttOtherTurkeyModal = true
      this.the_user_id = id
      this.editQttOtherTurkeyData.order_id = orderId
    },

    closeEditQttOtherTurkeyModal() {
      this.editQttOtherTurkeyModal = false
      this.editQttOtherTurkeyData.quantity_charge_other_turkey = ''
      this.seccessAlert = false
    },

    editQttOtherTurkey() {
      let token = localStorage.getItem('access_token')
      axios
        .put(this.editQttOtherTurkeyUrl + '/' + this.the_user_id, this.editQttOtherTurkeyData, {
          headers: { Authorization: 'Bearer ' + token }
        })
        .then((response) => {
          this.seccessAlert = true
          this.editQttOtherTurkeyData.quantity_charge_other_turkey = ''
          this.getResults()
          let a = this
          setTimeout(function () {
            a.updateData.quantity_charge = a.r.quantity_charge
            a.calculateTotalAmount()
          }, 1000)
        })
        .catch((error) => {
          this.editQttOtherTurkeyData.quantity_charge_other_turkey = ''
          swal(this.$t('common.error'), `${error.response.data.message}`, 'error')
        })
    }
  }
}
</script>

<style>
.dialog-dialog--active-dialog--persistent {
  opacity: 1 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
.dialog:not(.dialog--fullscreen) {
  max-height: 95%;
}

.input-group.input-group--selection-controls label {
  left: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/processTheOrder.vue